// /api/website/reserve/web/channelStore
export const request = ({ url = '', data = {},method='PUT'}) => {
             fetch(`${process.env.VUE_APP_BASEURL}${url}`,{
        method,
        body: JSON.stringify(data),
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      })
}